"use strict";
var core_1 = require('@angular/core');
var platform_browser_1 = require('@angular/platform-browser');
var ClickOutsideDirective = (function () {
    function ClickOutsideDirective(_document /*: HTMLDocument*/, _el) {
        this._document = _document;
        this._el = _el;
        this.attachOutsideOnClick = false;
        this.exclude = '';
        this.clickOutside = new core_1.EventEmitter();
        this._nodesExcluded = [];
        this._initOnClickBody = this._initOnClickBody.bind(this);
        this._onClickBody = this._onClickBody.bind(this);
    }
    ClickOutsideDirective.prototype.ngOnInit = function () {
        this._init();
    };
    ClickOutsideDirective.prototype.ngOnDestroy = function () {
        if (this.attachOutsideOnClick) {
            this._el.nativeElement.removeEventListener('click', this._initOnClickBody);
        }
        this._document.body.removeEventListener('click', this._onClickBody);
    };
    ClickOutsideDirective.prototype.ngOnChanges = function (changes) {
        if (changes['attachOutsideOnClick'] || changes['exclude']) {
            this._init();
        }
    };
    ClickOutsideDirective.prototype._init = function () {
        var _this = this;
        if (this.exclude) {
            this.exclude.split(',').forEach(function (selector) {
                if (selector) {
                    try {
                        var node = _this._document.querySelector(selector.trim());
                        if (node) {
                            _this._nodesExcluded.push(node);
                        }
                    }
                    catch (err) {
                        if (window.console) {
                            window.console.error('[ng2-click-outside] Check your exclude selector syntax.', err);
                        }
                    }
                }
            });
        }
        if (this.attachOutsideOnClick) {
            this._el.nativeElement.addEventListener('click', this._initOnClickBody);
        }
        else {
            this._initOnClickBody();
        }
    };
    /** @internal */
    ClickOutsideDirective.prototype._initOnClickBody = function () {
        this._document.body.addEventListener('click', this._onClickBody);
    };
    /** @internal */
    ClickOutsideDirective.prototype._onClickBody = function (e) {
        if (!this._el.nativeElement.contains(e.target) && !this._shouldExclude(e.target)) {
            this.clickOutside.emit(e);
            if (this.attachOutsideOnClick) {
                this._document.body.removeEventListener('click', this._onClickBody);
            }
        }
    };
    /** @internal */
    ClickOutsideDirective.prototype._shouldExclude = function (target) {
        for (var i = 0; i < this._nodesExcluded.length; i++) {
            if (this._nodesExcluded[i].contains(target)) {
                return true;
            }
        }
        return false;
    };
    ClickOutsideDirective.decorators = [
        { type: core_1.Directive, args: [{ selector: '[clickOutside]' },] },
    ];
    /** @nocollapse */
    ClickOutsideDirective.ctorParameters = [
        { type: undefined, decorators: [{ type: core_1.Inject, args: [platform_browser_1.DOCUMENT,] },] },
        { type: core_1.ElementRef, },
    ];
    ClickOutsideDirective.propDecorators = {
        'attachOutsideOnClick': [{ type: core_1.Input },],
        'exclude': [{ type: core_1.Input },],
        'clickOutside': [{ type: core_1.Output },],
    };
    return ClickOutsideDirective;
}());
exports.ClickOutsideDirective = ClickOutsideDirective;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-click-outside/lib/click-outside.directive.js
// module id = ./node_modules/ng2-click-outside/lib/click-outside.directive.js
// module chunks = vendor